import { FC, useEffect } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { CollectionsValues } from '../types'

import { FilterAndSort } from './FilterAndSort'
import { TagFilterBar } from './TagFilterBar'
import { FiltersProps } from './types'
import { Wrapper } from '@lounge-fe/ui-kit'
import { GridSizeSelector } from './GridSizeSelector'
import { t } from 'i18next'

export const Filters: FC<FiltersProps> = ({
  tags,
  sortOptions,
  filterSections,
  tagsInputName = 'tags',
  onSubmit,
  isLoading,
  defaultValues,
  ...props
}) => {
  const methods = useForm<CollectionsValues>({
    ...props,
    defaultValues,
  })

  useEffect(() => {
    const subscription = methods.watch(() => methods.handleSubmit(onSubmit)())
    return () => subscription.unsubscribe()
  }, [methods.handleSubmit, methods.watch])

  return (
    <FormProvider {...methods}>
      {tags && tags.length > 0 && (
        <TagFilterBar name={tagsInputName} tags={tags} isLoading={isLoading} />
      )}
      <Wrapper
        size="fluid"
        className="border-t border-[#E7E7E7] sticky top-0 bg-primary z-[15]"
      >
        <div className="flex flex-row justify-between py-6">
          <FilterAndSort
            title={t('action.filter_and_sort')}
            sortOptions={sortOptions}
            filterSections={filterSections}
          />
          <GridSizeSelector />
        </div>
      </Wrapper>
    </FormProvider>
  )
}
